module.exports = __webpack_public_path__ + "assets/img/ddk.c3c5a398.png";